import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { motion } from 'framer-motion'

import PinInput from '@/components/common/PinInput/PinInput'
import ResendCode from '@components/auth/ResendCode/ResendCode'
import Logo from '@components/common/Logo/Logo'

import MotionText from '@/components/common/Motion/MotionText'
import { usePageSetup } from '@/hooks/usePageSetup'

import passwordsAPI from '@/services/api/passwords'

export const PasswordCodePage = () => {
  const { t } = useTranslation()
  usePageSetup(t('auth.pageTitle.passwordCode'), { scroll: true, noindex: true })

  const [error, setError] = useState<string | undefined>()

  const navigate = useNavigate()
  const location = useLocation()
  const email = location.state?.email


  const pinSubmit = async (code: string) => {

    try {
      const response = await passwordsAPI.verify({ email, code })
      const token = response.token

      navigate("/password/reset", { state: { token } })
    } catch (error: any) {
      setError(t('auth.invalidCode'))
    }
  }

  return (
    <form className="h-full bg-white p-5 pt-8 pb-8 flex flex-col">
      <div className="space-y-4">
        <Logo />
      </div>

      <div className="flex-1 flex flex-col">
        <div className='h-[2rem] w-1'></div>
        <div className="space-y-4">
          <MotionText
            as="h2"
            className="text-zinc-900 text-3xl font-bold leading-tight"
            delay={0.2}
          >
            {t('auth.codeSent')}
          </MotionText>
          <MotionText
            as="p"
            className="text-zinc-700 text-base"
            delay={0.4}
          >
            {t('auth.securityCodeSentTo', { email })}
          </MotionText>
        </div>
        <motion.div className='my-6 flex flex-row gap-2'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.3,
            ease: "easeInOut"
          }}
        >
          <PinInput
            onChange={(value) => value.length === 6 && pinSubmit(value)}
            error={error}
          />
        </motion.div>
        <ResendCode
          initialSeconds={59}
          onResend={async () => passwordsAPI.forgot({ email })}
        />
      </div>
    </form>
  )
}

export default PasswordCodePage